
import modal from '../utils/modal.js';

const stripe = Stripe(window.STRIPE_PUBLIC_KEY);
const stripeGateway = {

    initialize: (idElement) => {
        
        if(!$(`#${idElement}`) ||  $(`#${idElement}`).length <= 0) {
            console.error('Stripe not initliazed');
            return false;
        }

        const colorCard = $("section#main").hasClass('wt-bg-white')  ? "#0C619D": "#FFF";
        const elements = stripe.elements();
        const card = elements.create("card", {
            iconStyle: "solid",
            style: {
                base: {
                    border: '2px solid white',
                    color: colorCard,
                    lineHeight: '24px',
                    iconColor: colorCard,
                    fontWeight: 400,
                    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
                    fontSize: "16px",
                    fontSmoothing: "antialiased",

                    "::placeholder": {
                        color: "#757575"
                    },
                    ":-webkit-autofill": {
                        color: "#757575"
                    }
                },
                invalid: {
                    iconColor: "red",
                    color: "red"
                }
            }
        });

        card.mount(`#${idElement}`);
        return card;
    },

    /**
     * Send checkout | Stripe
     * @param selector form 
     */
    checkout: (card, cardOwner, _callback) => {
        
        stripe.createToken(card, { name: cardOwner }).then(function (result) {
            
            if (result.error) {
                modal.closeModal();
                modal.errorModal('Error', result.error.message);
                _callback();
            } else {
                _callback(result.token.id);
            }
        }).catch(function(error) {
            modal.closeModal();
            modal.errorModal('Error', 'Internal error');
            _callback();
        });
    }

}

export default stripeGateway;
